export default "__VITE_ASSET__33194982__"